<template>
    <div v-if="!nextFlag">
        <div class="d-flex justify-content-between my-3">
            <router-link class="back-route h3" ref="backBtn" @click="backHandler($event, null)"
                         :to="isData ? '#':'/templates'">
                    <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                Create Template
            </router-link>
        </div>

        <div class="tabcontent">
            <form class="form-container row d-flex flex-column justify-content-between">
                <div class="d-flex flex-column gap-3 justify-content-between">
                    <div class="row d-flex">
                        <NameComponent class="col-md-6" :name="template"
                                       :inputHandler="() => {}" :lable="'Template Name'"
                                       :err="errors['name']"/>
                    </div>
                    <DescriptionComponent :description="template"
                                          type="template-description"
                                          :lable="'Template Description'"
                                          :err="errors['description']"/>

                    <div class="d-flex justify-content-between gap-4">
                        <div class="w-50  position-relative">
                            <label>Template Material</label>
                            <div class="files-upload-container position-relative">

                                <div class="position-absolute"
                                     :class="{'': templateMaterial.length === 0,'preview-files': templateMaterial.length > 0 }">
                                    <div class="material-preview" v-for="(item, idx) in templateMaterial">
                                         <span class="img-delete-icon position-absolute"
                                               @click="removeMaterialHandler($event, idx)">
                                                    <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                                </span>

                                        <span>
                                            <img class="file-img-icon" title="View Matrial"

                                                 @click="viewHandler($event,item['file'], item['type'], item['fileName'])"
                                                 :src="getFileIcon(item['type'],'')" width="60"/>
                                                </span>
                                        <div class="file-name" :title="item['fileName']">{{item['fileName']}}</div>
                                    </div>
                                </div>


                                <div class="material-container-no-data" @click="uploadeManyFn"
                                     v-if="templateMaterial.length === 0">
                                    <FilePondDemo v-if="!lightMood" @fileStart="fileStart"

                                                  @fileRemove="fileRemove"
                                                  @fileUpload="fileUpload"
                                                  :accepted="acceptedTypes"
                                                  :allowMultiple="true"
                                                  content='<div class=""><svg xmlns="http://www.w3.org/2000/svg" width="100" height="30" viewBox="0 0 66.197 54.677">
                                                                        <path id="Path_101839" data-name="Path 101839" d="M34.967,29.483,23.483,18,12,29.483" transform="translate(9.603 12.334)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                        <path id="Path_101840" data-name="Path 101840" d="M18,18V43.837" transform="translate(15.087 12.334)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                        <path id="Path_101841" data-name="Path 101841" d="M57.173,48.679a14.354,14.354,0,0,0-6.861-26.957H46.694A22.967,22.967,0,1,0,7.249,42.679" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                        <path id="Path_101842" data-name="Path 101842" d="M34.967,29.483,23.483,18,12,29.483" transform="translate(9.603 12.334)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
                                                                    </svg><div class="my-3" style="color:var(--main-color)">Drop Files Here or <span class="filepond--label-action">Browse</span></div></div>'
                                    />

                                    <FilePondDemo v-else @fileStart="fileStart"

                                                  @fileRemove="fileRemove"
                                                  @fileUpload="fileUpload"
                                                  :accepted="acceptedTypes"
                                                  :allowMultiple="true"
                                                  content='<div class=""><svg xmlns="http://www.w3.org/2000/svg" width="100" height="30" viewBox="0 0 66.196 54.678">
  <g id="Icon_feather-upload-cloud" data-name="Icon feather-upload-cloud" transform="translate(0.019 -2.994)">
    <path id="Path_101839" data-name="Path 101839" d="M34.967,29.483,23.483,18,12,29.483" transform="translate(9.603 12.334)" fill="none" stroke="#f47c2c" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
    <path id="Path_101840" data-name="Path 101840" d="M18,18V43.837" transform="translate(15.087 12.334)" fill="none" stroke="#f47c2c" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
    <path id="Path_101841" data-name="Path 101841" d="M57.173,48.679a14.354,14.354,0,0,0-6.861-26.957H46.694A22.967,22.967,0,1,0,7.249,42.679" transform="translate(0 0)" fill="none" stroke="#f47c2c" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
    <path id="Path_101842" data-name="Path 101842" d="M34.967,29.483,23.483,18,12,29.483" transform="translate(9.603 12.334)" fill="none" stroke="#f47c2c" stroke-linecap="round" stroke-linejoin="round" stroke-width="3"/>
  </g>
</svg><div class="my-3" style="color: var(--main-color)">Drop Files Here or <span class="filepond--label-action" style="color:#e95626">Browse</span></div></div>'
                                    />

                                    <div class="material-error-no-data">
                                        <div class="text-danger specificError" v-for="err in template.errors.material">
                                            {{err}}
                                        </div>
                                    </div>
                                </div>

                                <div class="material-container" @click="uploadeManyFn" v-else>

                                    <div class="material-error">
                                        <div class="text-danger" v-for="err in template.errors.material">
                                            {{err}}
                                        </div>
                                    </div>

                                    <FilePondDemo @fileStart="fileStart" @fileRemove="fileRemove"
                                                  @fileUpload="fileUpload"
                                                  :accepted="acceptedTypes" :allowMultiple="true"
                                                  content='<div class=""><div class="my-3" style="color: var(--main-color)">Drop Files Here or <span class="filepond--label-action">Browse</span></div></div>'/>


                                </div>

                            </div>
                        </div>
                        <div class="w-50">
                            <label>Template Videos</label>

                            <div class="video-upload-container p-3">
                                <div class="video-show-container">
                                    <div v-if="template.videos.length > 0" class="position-relative video-show-section"
                                         v-for="(video, idx ) in template.videos">
                                     <span class="position-absolute delete-icon"
                                           @click="deleteVideoHandler($event, idx)">
                                                    <font-awesome-icon :icon="['fas', 'times']" size="sm"/>
                                                </span>
                                        <iframe width="150" height="100"
                                                :src="video">
                                        </iframe>
                                    </div>
                                    <div class="w-100" v-else>
                                        <p class="text-center">Add Video Link</p>
                                    </div>
                                </div>
                                <div class="d-flex justify-content-start align-items-center gap-3">
<!--                                    <label for="video-material">Add Video</label>-->
                                    <input id="video-material" type="text" placeholder="Enter URL" v-model="videoUrl"/>
                                    <a class="add-video-btn" @click="addVideoHandler">+</a>
                                </div>
                                <div>
                                    <div class="text-danger" v-for="err in template.errors.videos">
                                        {{err}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="pt-3">
                <div class="d-flex justify-content-end">
                    <label for="inputName" class="form-label custom-label m-0">Active Material</label>
                </div>
                <div class="d-flex justify-content-end align-items-center">
                    <label class="switch">
                        <input type="checkbox" @change="checkChange">
                        <span class="slider round"></span>
                    </label>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-end my-3">
            <button class="next-btn" @click="nextHandler">Next</button>
        </div>
    </div>
    <div v-else>
        <div class="container-fluid">
            <div class="row py-3">
                <div class="col-md-12 px-0 d-flex justify-content-between">
                    <router-link class="back-route h3" ref="backBtn" @click="backHandler($event, 'back')"
                                 :to="isData ? '#':'/templates/create'">
                        <font-awesome-icon :icon="['fas', 'angle-left']" size="lg"/>
                        {{pageTitle}}
                    </router-link>

                    <div class="save-btn"
                         :style="(
                             template.questionsCount === 0 ||
                             template.questions['trueOrFalse'].isError ||
                             template.questions['multipleChoices'].isError ||
                             template.questions['freeText'].isError ||
                             template.questions['slides'].isError ||
                             template.questions['rank'].isError ||
                             template.questions['arrange'].isError
                             )  ?  {cursor: 'not-allowed'} : {cursor: 'pointer'}">
                        <button @click="saveHandler" class="form-control btn btn-primary w-100"
                                :style="(
                                    template.questionsCount === 0 ||
                                    template.questions['trueOrFalse'].isError ||
                                    template.questions['multipleChoices'].isError ||
                                    template.questions['freeText'].isError ||
                                    template.questions['slides'].isError ||
                                    template.questions['trueOrFalse']['errors']['weight']['isError'] ||
                                    template.questions['multipleChoices']['errors']['weight']['isError'] ||
                                    template.questions['freeText']['errors']['weight']['isError'] ||
                                    template.questions['slides']['errors']['weight']['isError'] ||
                                    template.questions['rank']['errors']['weight']['isError'] ||
                                    template.questions['arrange']['errors']['weight']['isError']
                                       )  ?  {cursor: 'not-allowed'} : {cursor: 'pointer'}">
                            Save Template
                        </button>
                    </div>
                </div>
                <tabsComponent :template="template" @setTitle="titleHandler($event)" opType="create"/>
            </div>
        </div>
    </div>

    <AlartModal v-if="showModal" message="Template Created" imagePath="okImage.svg" @close-modal="showModal = false"/>

    <ConfirmationModal v-if="isFull || confirmModal" :message="confirmMessage" confirmBtn="Yes" cancleBtn="No"
                       @close-modal="confirmModalHandler($event)"/>
    <span v-if="lightMood"></span>
</template>

<script>

    import {computed, defineAsyncComponent, onMounted, ref} from "vue";
    import {useStore} from "vuex";
    import {useRouter} from 'vue-router';
    import tabsComponent from '../template/tabsComponent';
    import repository from "../../../api-services/repository";
    import router from "../../../router";

    import NameComponent from "../../components/templateComponents/nameComponent";
    import DescriptionComponent from "../../components/templateComponents/descriptionComponent";

    import FilePondDemo from '../../components/FilePondDemo';
    import getFileExt from "../../../helpers/getFileExt";
    import store from "../../../store";

    const AlartModal = defineAsyncComponent(() =>
        import ('../../components/AlartModal')
    );

    const ConfirmationModal = defineAsyncComponent(() =>
        import ('../../components/ConfirmationModal')
    );

    export default {
        name: 'app',
        components: {tabsComponent, AlartModal, ConfirmationModal, NameComponent, DescriptionComponent, FilePondDemo},

        setup() {
            const store = useStore();
            const router = useRouter();
            const showModal = ref(false);
            const uploadeMany = ref(false);
            const lightMood = computed({
                get() {
                    return store.state.settings.isLightMood;
                },
            });
            const isFull = ref(false);
            const Imgs = ref({});
            const slidesImgs = ref([]);
            const slidesCat = ref([]);
            const videoUrl = ref('');
            const acceptedTypes = ref([
                "application/vnd.openxmlformats-officedocument.presentationml.presentation",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/pdf",
                "application/x-tar",
                "application/x-msdownload",
                "application/x-zip-compressed",
                "text/plain",
                "image/png",
                "image/jpg"
            ]);
            const template = ref(
                {
                    name: '',
                    matrial_status: null,
                    description: '',
                    questionsCount: 0,
                    material: [],
                    videos: [],
                    errors: {
                        "videos": [],
                        "material": []
                    },
                    questions: {
                        trueOrFalse: {
                            weight: null,
                            counter: 0,
                            title: "True or False",
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {
                                            value: 'True',
                                            is_correct: false
                                        },
                                        {
                                            value: 'False',
                                            is_correct: false
                                        }
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: []
                                    }
                                }
                            ],
                            isError: false,
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                        multipleChoices: {
                            weight: null,
                            counter: 0,
                            title:'Multiple Choice',
                            isError: false,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {
                                            key: 'Choice',
                                            value: '',
                                            is_correct: false
                                        },
                                        {
                                            key: 'Choice',
                                            value: '',
                                            is_correct: false
                                        }
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: [],
                                        general: []
                                    }
                                }
                            ],
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                        freeText: {
                            weight: null,
                            counter: 0,
                            title:'Free Text',
                            isError: false,
                            questions: [
                                {
                                    question: '',
                                    answer: '',
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answer: []
                                    }
                                }
                            ],
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                        slides: {
                            weight: null,
                            counter: 0,
                            title:'Slides',
                            isError: false,
                            name: '',
                            description: '',
                            images: [],
                            category: [],
                            errors: {
                                weight: {isError: false, message: ''},
                                name: [],
                                description: [],
                                slides: [],
                                categoryName: [],
                                categorySlides: [],
                            }
                        },
                        rank: {
                            weight: null,
                            title:'Rank',
                            counter: 0,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {value: 1, is_correct: false}, {value: 2, is_correct: false}, {value: 3, is_correct: false},
                                        {value: 4, is_correct: false}, {value: 5, is_correct: false}, {value: 6, is_correct: false},
                                        {value: 7, is_correct: false}, {value: 8, is_correct: false}, {value: 9, is_correct: false},
                                        {value: 10, is_correct: false}
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: []
                                    }
                                }
                            ],
                            isError: false,
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                        arrange: {
                            weight: null,
                            title:'Arrange',
                            counter: 0,
                            isError: false,
                            questions: [
                                {
                                    question: '',
                                    answers: [
                                        {
                                            order: 1,
                                            value: '',
                                            bgColor: 'transparent',
                                            is_correct: false
                                        },
                                        {
                                            order: 2,
                                            value: '',
                                            bgColor: 'transparent',
                                            is_correct: false
                                        },
                                    ],
                                    isDelete: true,
                                    errors: {
                                        question: [],
                                        answers: [],
                                        general: []
                                    }
                                }
                            ],
                            errors: {
                                weight: {isError: false, message: ''}
                            }
                        },
                    }
                });

            const templateMaterial = ref([]);
            const files = ref({
                data: [],
                template_id: ''
            });

            const filesChunked = ref({
                data: [],
                template_id: '',

            });

            const attachmentsChunked = ref({
                data: [],
                template_id: '',
                slideInfo: '',
                categoriesInfo: [],
                slideCategories: {},
            });

            const errors = ref({
                name: [],
                description: []
            });

            const pageTitle = ref('True or False');

            const nextFlag = ref(false);

            onMounted(async () => {
                await store.dispatch('activeTap', 'templates');
            });

            const uploadeManyFn = () => {

                uploadeMany.value = true;
            };

            const checkChange = (e) => {
                template.value.matrial_status = 0;
                if (e.target.checked === true) {
                    template.value.matrial_status = 1;
                } else {
                    template.value.matrial_status = 0;
                }
            };

            const checkData = async () => {
                let temp = template.value;
                let retValue = false;
                if (((temp.name.length > 0) || (temp.description.length > 0))) {
                    retValue = true;
                    await store.dispatch('setDataFlag', true);
                } else {
                    await store.dispatch('setDataFlag', false);
                }
                return retValue;
            };

            const backHandler = async (e, type = null) => {
                let check = null;
                if (type !== null) {
                    nextFlag.value = false;
                } else {
                    check = checkData();
                    await check.then((item) => {
                        check = item
                    });

                    if (((check) || (template.value.questionsCount > 0))) {
                        await store.dispatch('setDataFlag', true);
                        await store.dispatch('setConfirmMessage', 'Are you sure you want to go back and remove all data?');
                        isFull.value = true;
                    } else {
                        isFull.value = false;
                        await store.dispatch('setDataFlag', false);
                        nextFlag.value = false;
                    }
                }

            };

            const saveHandler = async () => {
                let count = template.value.questionsCount;
                let isWeightError = (
                       template.value.questions['trueOrFalse']['errors']['weight']['isError']
                    || template.value.questions['multipleChoices']['errors']['weight'] ['isError']
                    || template.value.questions['freeText']['errors']['weight'] ['isError']
                    || template.value.questions['slides']['errors']['weight']['isError']
                    || template.value.questions['rank']['errors']['weight']['isError']
                    || template.value.questions['arrange']['errors']['weight']['isError']
                );
                let isError = (
                       template.value.questions['trueOrFalse'].isError
                    || template.value.questions['multipleChoices'].isError
                    || template.value.questions['freeText'].isError
                    || template.value.questions['slides'].isError
                    || template.value.questions['rank'].isError
                    || template.value.questions['arrange'].isError
                )
                if ((count !== 0) && (!isError) && (!isWeightError)) {
                    try {

                        slidesCat.value = await template.value.questions.slides.category.map((obj) => ({ ...obj }));
                        console.log('slidesCat.value - brfore ', slidesCat.value)
                        let data = await removeUnusedData();
                        let slideAttachments = [];
                        console.log({data})
                        if (data['slides'].images) {
                            slideAttachments = [...data['slides'].images];
                            data.slides.images = null;
                        }


                        console.log({slideAttachments})
                        let resData = await repository.create('templates', data);

                        console.log({resData})
                        if (slideAttachments.length > 0 && resData.data.statusCode === 201) {

                            const chunkSize = 5;
                            
                            for (let i = 0; i < slideAttachments.length; i += chunkSize) {

                                // formData.append('template_id', resData.data.data.template_id);
                                // formData.append('data[]', slideAttachments.slice(i, i + chunkSize));
                                // formData.append('categoriesInfo[]', resData.data.data.slidesData.data.categoriesInfo);
                                // formData.append('slideCategories[]',  resData.data.data.slidesData.data.slideCategories);
                                // formData.append('slideInfo', resData.data.data.slidesData.data.slideInfo);
                                attachmentsChunked.value.data = slideAttachments.slice(i, i + chunkSize);
                                attachmentsChunked.value.template_id = resData.data.data.template_id;
                                attachmentsChunked.value.categoriesInfo = resData.data.data.slidesData.data.categoriesInfo;
                                attachmentsChunked.value.slideCategories = resData.data.data.slidesData.data.slideCategories;
                                attachmentsChunked.value.slideInfo = resData.data.data.slidesData.data.slideInfo;

                                await repository.uploadAttachments(attachmentsChunked.value)
                            }
                            // files.value.template_id = resData.data.data.template_id;
                            // await repository.uploadMaterial(files.value)

                        }

                        if (files.value.data.length > 0 && resData.data.statusCode === 201) {
                            // const formData = new FormData();
                            // formData.append('template_id', resData.data.data.template_id);
                            // files.value.data.forEach((file) => {
                            //     formData.append('files[]', file);
                            // })

                            const chunkSize = 5;
                            for (let i = 0; i < files.value.data.length; i += chunkSize) {
                                filesChunked.value.data = files.value.data.slice(i, i + chunkSize);
                                filesChunked.value.template_id = resData.data.data.template_id;
                                await repository.uploadMaterial(filesChunked.value)
                            }
                            // files.value.template_id = resData.data.data.template_id;
                            // await repository.uploadMaterial(files.value)

                        }

                        await store.dispatch('setDataFlag', false);
                        await store.dispatch('setSuccessModal', true);
                        await store.dispatch('setSueccessMessage', resData.data.message);
                        setTimeout(() => {
                            router.push({path: '/templates'});
                        }, 1000);
                        await clearTemplateData();

                    } catch (e) {

                        console.log('tem ', template.value, slidesImgs.value, slidesCat.value)
                        if(slidesImgs.value.length > 0){
                             template.value.questions.slides.images = slidesImgs.value;
                             // template.value.questions.slides.category = slidesCat.value;
                        }
                        for (const property in e.response.data.errors) {
                            let key = property.split('.')[0];
                            let idx = property.split('.')[2];
                            let error = property.split('.')[3];
                            console.log({key}, {e})
                            if (key === 'name') {
                                nextFlag.value = false;
                                errors.value['name'] = e.response.data.errors['name']
                            } else {
                                if (key !== 'slides') {
                                    template.value.questions[key].questions[idx].errors[error] = [];
                                    template.value.questions[key].questions[idx].errors[error].push(e.response.data.errors[property][0]);
                                } else {
                                    template.value.questions[key].category[idx].error[error] = [];
                                    template.value.questions[key].category[idx].error[error].push(e.response.data.errors[property][0]);
                                }
                            }

                        }
                    }

                } else {
                    // else logic
                }
            };

            const titleHandler = (e) => {
                pageTitle.value = e;
            };

            const removeUnusedData = () => {
                let data = {...template.value};
                for (let [key, value] of Object.entries(data.questions)) {

                    console.log(key, value)
                    if (value.counter === 0) {
                        data[key] = [];
                        // delete data.questions[key];
                    } else {
                        data[key] = data.questions[key];
                    }

                    if (key === 'slides') {
                        if (value['images'].length > 0) {
                            slidesImgs.value = value['images'];
                            data[key].category.forEach((cat) => {
                                cat.images.forEach((img) => {
                                    img.path = null;
                                })
                            })
                        }

                    }


                }
                delete data.questions;

                return data;
            };

            const clearTemplateData = () => {
                nextFlag.value = false;
                template.value =
                    {
                        name: '',
                        matrial_status: null,
                        description: '',
                        questionsCount: 0,
                        material: [],
                        videos: [],
                        errors: {
                            "videos": [],
                            "material": []
                        },
                        questions: {
                            trueOrFalse: {
                                weight: null,
                                counter: 0,
                                questions: [
                                    {
                                        question: '',
                                        answers: [
                                            {
                                                value: 'True',
                                                is_correct: false
                                            },
                                            {
                                                value: 'False',
                                                is_correct: false
                                            }
                                        ],
                                        isDelete: true,
                                        errors: {
                                            question: [],
                                            answers: []
                                        }
                                    }
                                ],
                                isError: false,
                                errors: {
                                    weight: {isError: false, message: ''}
                                }
                            },
                            multipleChoices: {
                                weight: null,
                                counter: 0,
                                isError: false,
                                questions: [
                                    {
                                        question: '',
                                        answers: [
                                            {
                                                key: 'Choice',
                                                value: '',
                                                is_correct: false
                                            },
                                            {
                                                key: 'Choice',
                                                value: '',
                                                is_correct: false
                                            }
                                        ],
                                        isDelete: true,
                                        errors: {
                                            question: [],
                                            answers: [],
                                            general: []
                                        }
                                    }
                                ],
                                errors: {
                                    weight: {isError: false, message: ''}
                                }
                            },
                            freeText: {
                                weight: null,
                                counter: 0,
                                isError: false,
                                questions: [
                                    {
                                        question: '',
                                        answer: '',
                                        isDelete: true,
                                        errors: {
                                            question: [],
                                            answer: []
                                        }
                                    }
                                ],
                                errors: {
                                    weight: {isError: false, message: ''}
                                }
                            },
                            slides: {
                                weight: null,
                                counter: 0,
                                isError: false,
                                name: '',
                                description: '',
                                images: [],
                                category: [],
                                errors: {
                                    weight: {isError: false, message: ''},
                                    name: [],
                                    description: [],
                                    slides: [],
                                    categoryName: [],
                                    categorySlides: [],
                                }
                            },
                            rank: {
                                weight: null,
                                counter: 0,
                                questions: [
                                    {
                                        question: '',
                                        answers: [
                                            {value: 1, is_correct: false}, {value: 2, is_correct: false}, {value: 3, is_correct: false},
                                            {value: 4, is_correct: false}, {value: 5, is_correct: false}, {value: 6, is_correct: false},
                                            {value: 7, is_correct: false}, {value: 8, is_correct: false}, {value: 9, is_correct: false},
                                            {value: 10, is_correct: false}
                                        ],
                                        isDelete: true,
                                        errors: {
                                            question: [],
                                            answers: []
                                        }
                                    }
                                ],
                                isError: false,
                                errors: {
                                    weight: {isError: false, message: ''}
                                }
                            },
                            arrange: {
                                weight: null,
                                counter: 0,
                                isError: false,
                                questions: [
                                    {
                                        question: '',
                                        answers: [],
                                        isDelete: true,
                                        errors: {
                                            question: [],
                                            answer: []
                                        }
                                    }
                                ],
                                errors: {
                                    weight: {isError: false, message: ''}
                                }
                            },
                        }
                    };

                templateMaterial.value = [];
                files.value['data'] = [];
            };

            const nextHandler = async () => {
                let tempName = template.value['name'];
                let tempDescription = template.value['description'];


                if (tempName !== '' && tempDescription !== '') {
                    nextFlag.value = true;
                    errors.value['name'] = [];
                    errors.value['description'] = [];
                    await store.dispatch('setDataFlag', true);
                } else {
                    console.log({tempName})
                    if (tempName === '')
                        errors.value['name'] = ['*Required'];
                    else
                        errors.value['name'] = [];

                    if (tempDescription === '')
                        errors.value['description'] = ['*Required'];
                    else
                        errors.value['description'] = [];

                    nextFlag.value = false;
                    await store.dispatch('setDataFlag', false);
                }
            };

            const confirmModalHandler = async (event) => {
                isFull.value = false;
                await store.dispatch('setConfirmModal', false);
                if (event) {
                    await store.dispatch('setDataFlag', false);
                    await router.push('/' + store.state.settings.currentRoute);
                }
            };

            const fileUpload = (e) => {

                if (uploadeMany.value) {
                    template.value.errors['material'] = [];
                    uploadeMany.value = false;
                }
                console.log("file => ", e['file']);
                if (acceptedTypes.value.includes(e['file']['type'])) {
                    if (e['file']['size'] < 10000000) {
                        const reader = new FileReader();
                        reader.onload = async function (event) {
                            const fileData = {
                                'id': e['id'],
                                'type': e['file']['type'],
                                'fileName': e['file']['name'],
                                'file': event.target.result
                            };
                            templateMaterial.value.push(fileData);
                            files.value['data'].push(fileData);
                            console.log(template.value.material)
                        };
                        reader.readAsDataURL(e['file']);
                    } else {
                        let errorMsg = `*File must not be more than 10 MB`;
                        template.value.errors['material'].push(errorMsg)
                    }
                } else {
                    let errorMsg = `* error in file type`;
                    template.value.errors['material'].push(errorMsg)
                }
                console.log("file => ", e['file']);

                // if (acceptedTypes.value.includes(e['file']['type'])) {
                //     if(e['file']['size'] < 10000000 ){
                //         const fileData = {
                //             'id': e['id'],
                //             'type': e['file']['type'],
                //             'fileName': e['file']['name'],
                //             'file':e['file']
                //         };
                //
                //         console.log({fileData})
                //         templateMaterial.value.push(fileData);
                //         files.value['data'].push(e['file']);
                //     }else{
                //         let errorMsg = `* ${e['file']['name']} must not be less than 5 MB`;
                //         template.value.errors['material'].push(errorMsg)
                //     }
                //
                // } else {
                //     let errorMsg = `* error in file type`;
                //     template.value.errors['material'].push(errorMsg)
                // }
            };

            const fileRemove = (e) => {
                template.value.material = template.value.material.filter((item) => {
                    return item.id !== e['id']
                });
                console.log(template.value.material)
            };

            const removeMaterialHandler = (e, idx) => {
                // template.value.material.splice(idx, 1);
                templateMaterial.value.splice(idx, 1);
                files.value['data'].splice(idx, 1);
            };

            const fileStart = async (e) => {
                // await store.dispatch('setIsLoading', true);
            };

            const deleteVideoHandler = (e, idx) => {
                template.value.videos.splice(idx, 1);
            };

            const addVideoHandler = () => {

                const pattern = /^((?:https?:\/\/)?(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b[-a-zA-Z0-9@:%_\+.~#?&\/=]*|)$/;
                let test = pattern.test(videoUrl.value);

                if ((videoUrl.value !== '') && (test)) {
                    template.value.errors['videos'] = [];
                    let youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                    let youTubeMatch = videoUrl.value.match(youTubeRegExp);

                    let vimeoRegExp = /(?:vimeo)\.com.*(?:videos|video|channels|)\/([\d]+)/i;
                    let vimeoMatch = videoUrl.value.match(vimeoRegExp);

                    console.log({vimeoMatch}, {youTubeMatch})

                    if (youTubeMatch && youTubeMatch[2].length === 11) {
                        console.log(`https://www.youtube.com/embed/${youTubeMatch[2]}`)
                        template.value.videos.push(`https://www.youtube.com/embed/${youTubeMatch[2]}`);
                    } else if (vimeoMatch && vimeoMatch.length > 0) {
                        template.value.videos.push(`https://player.vimeo.com/video/${vimeoMatch[1]}`);
                        console.log(`https://player.vimeo.com/video//${vimeoMatch[1]}`)
                    } else {
                        template.value.errors['videos'] = ['*Invalid URL'];
                    }

                    // template.value.videos.push(videoUrl.value);

                } else
                    template.value.errors['videos'] = ['*Invalid URL'];

                videoUrl.value = '';
            };

            const getFileIcon = (type, fileName) => {

                console.log({type});

                const ext = getFileExt(type, fileName);
                return require(`../../../assets/images/${ext}.png`);
            };

            const viewHandler = async (e, filePath, fileType = null, fileName = null) => {
                const link = document.createElement("a");
                link.href = filePath;
                link.download = `${fileName}`;
                link.click();
            };

            return {
                errors,
                template,
                nextFlag,
                pageTitle,
                showModal,
                isFull,
                videoUrl,
                acceptedTypes,
                uploadeMany,
                attachmentsChunked,
                slidesImgs,
                Imgs,
                slidesCat,
                isData: computed(() => store.state.settings.setDataFlag),
                confirmModal: computed(() => store.state.settings.confirmModal),
                confirmMessage: computed(() => store.state.settings.confirmMessage),
                lightMood: computed(() => store.state.settings.isLightMood),
                viewHandler,
                templateMaterial,
                files,
                uploadeManyFn,
                titleHandler,
                checkChange,
                backHandler,
                nextHandler,
                saveHandler,
                removeUnusedData,
                confirmModalHandler,
                clearTemplateData,
                checkData,
                getFileIcon,
                deleteVideoHandler,
                fileRemove,
                fileUpload, addVideoHandler,
                fileStart,
                filesChunked,
                removeMaterialHandler

            }
        }
    }
</script>

<style scoped>

    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

    .switch input {
        opacity: 0;
        width: 0;
        height: 0;
    }

    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

    .slider:before {
        position: absolute;
        content: "";
        height: 26px;
        width: 26px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        -webkit-transition: .4s;
        transition: .4s;
    }

    input:checked + .slider {
        background-color: #2196F3;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #2196F3;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

    .slider.round:before {
        border-radius: 50%;
    }

    #video-material {
        color: var(--main-color);
        padding: 8px;
    }

    .material-container-no-data {
        position: absolute;
        top: 36%;
        right: 0;
        width: 100%;
    }

    .material-container {
        position: absolute;
        top: 49%;
        width: 100%;
        right: 0;
    }

    .filepond--list-scroller {
        display: none !important;
    }

    .content {
        overflow-y: auto;
        display: block;
        padding: 30px;
        height: 70vh;
        border-top: none;
        background-image: linear-gradient(#16303a, #021A24);
        border-radius: 20px;
    }

    textarea {
        resize: none;
        height: 200px;
        min-height: 200px;
        max-height: 250px;
    }

    .next-btn {
        color: var(--main-color);
        background-color: transparent;
        border: 1px solid  var(--border-next-btn-template);
        border-radius: 4px;
        padding: 8px 60px 8px 60px;
    }

    .save-btn {
        width: 180px;
    }

    .save-btn button,
    .save-btn button:hover,
    .save-btn button:active {
        width: 100%;
        color: #fff;
        background-color: var(--btn-bg-color);
        padding: 8px;
        border-radius: 6px;
        font-weight: bold;
        border: none;
    }

    .files-upload-container,
    .video-upload-container {
        /*padding: 50px;*/
        border: 1px solid #39525C;
        border-radius: 15px;
        height: 290px;
        overflow-y: hidden;
    }

    .video-upload-container {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .video-upload-container input {
        background-color: transparent;
        border: 1px solid #39525C;
        color: #39525C;
        width: 75%;
    }

    .filepond--root .filepond--drop-label {
        background-color: transparent !important;
    }


    .filepond--list {
        overflow-y: auto !important;
        height: 105px !important;
    }

    .delete-icon {
        right: -5px;
        top: -5px;
        display: flex;
        border-radius: 50%;
        width: 14.2px;
        height: 14.2px;
        border: 1px solid #E95626;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #0e2731;
        background-color: #e95626;
        cursor: pointer;
    }

    .video-show-container {
        display: flex;
        padding: 7px;
        gap: 10px;
        overflow-x: auto;
        overflow-y: hidden;
        width: 100%;
        height: 110px;
    }

    .video-show-section {
        width: 150px;
    }

    /*.add-video-btn {*/
    /*    cursor: pointer;*/
    /*    color: #e65c00;*/
    /*    text-decoration: underline;*/
    /*}*/

    .add-video-btn {
        font-size: 18px;
        font-weight: 500;
        cursor: pointer;
        color: var(--link-active-border-color);
        border: 1px solid;
        border-radius: 50%;
        width: 25px;
        height: 25px;
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
        text-decoration: none;
    }

    .add-video-btn:hover {
        background-color: #e65c00;
        color: #032a3a;
    }

    .preview-files {
        top: 11px;
        /*background-image: linear-gradient(#07202a, #041c26);*/
        left: 0;
        width: 98%;
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        height: 53%;
        z-index: 5;
        /* overflow: auto; */
        overflow-y: auto;
        overflow-x: hidden;
        padding: 8px;
    }

    .material-preview {
        height: 85%;
        border: 1px solid #39525C;
        border-radius: 18px;
        width: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        gap: 10px;
        position: relative;
    }

    .img-delete-icon {
        right: -4px;
        top: -5px;
        width: 20px;
        height: 20px;
        border: 1px solid #e65c00;
        color: #e65c00;
        background-color: transparent;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    .file-name {
        text-overflow: ellipsis;
        overflow: hidden;
        width: 130px;
        height: 2.2em;
        align-self: flex-start;
        white-space: nowrap;
    }

    .material-error {
        height: 75px;
        padding: 8px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .material-error-no-data {
        position: absolute;
        width: 98%;
        z-index: 2;
        height: 114px;
        top: 67px;
        /* background-color: aliceblue; */
        /*background-image: linear-gradient(#07202a, #021a24);*/
        background-image: linear-gradient(var(--upload-section-bg1-color), var(--upload-section-bg2-color));
        left: 6px;
    }

    .material-error-no-data .specificError{
        position: absolute;
        top:57px;
    }

    .file-img-icon {
        cursor: pointer;
    }
</style>
